import React from "react";
import { Dropdown, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { sendTickerCommand } from "store/reducers/TabsSlice";
import { useAppSelector } from "hooks/redux";

const MassCommandsDropdown: React.FC = () => {
    const dispatch = useDispatch();

    const sections = useAppSelector(
        (state) => state.tabs.currentTab?.sections || [],
    );

    const sectionId = sections[0]?.id;

    const handleCommand = (cmd: string) => {
        if (!sectionId) {
            console.warn("Section ID not available");
            return;
        }

        dispatch(
            sendTickerCommand({
                ticker_name: "",
                command: cmd,
            }),
        );
    };

    const COMMANDS = [
        { label: "Перезагрузить с переподпиской", key: "RRO", disabled: false },
        { label: "Перезагрузить без переподписки", key: "RR", disabled: false },
        { label: "Перевод в бой ", key: "WTS", disabled: false },
        { label: "Перевод в вирт", key: "VTS", disabled: false },
        { label: "Перевод в закрытие", key: "SC", disabled: false },
        { label: "Отменить в закрытие", key: "CC", disabled: false },
        {
            label: "Выставить АЗ для всех стратегий",
            key: "SA",
            disabled: false,
        },
        { label: "Отменить счетчик АЗ", key: "RA", disabled: false },
        {
            label: "Получить путь к папке с конфигами",
            key: "SP",
            disabled: false,
        },
    ];

    if (!sectionId) {
        return null;
    }

    return (
        <Dropdown
            menu={{
                items: COMMANDS,
                onClick: ({ key }) => handleCommand(key),
            }}
            trigger={["click"]}
        >
            <Button onClick={(e) => e.preventDefault()}>
                <DownOutlined />
            </Button>
        </Dropdown>
    );
};

export default MassCommandsDropdown;
